import React from 'react';
import * as S from './styled';
import {
  congratulationEmailTitle,
  congratulationEmailSubtitle,
} from '../../utils/constants';

const CongratulationEmail = ({ email }) => (
  <S.StyledSection
    title={congratulationEmailTitle}
    subTitle={congratulationEmailSubtitle}
  >
    <S.Email>{email}</S.Email>
  </S.StyledSection>
);

export default CongratulationEmail;
